<ion-header>
    <ion-toolbar>
        <ion-title mode="md">
            <img class="logo" src="/assets/img/logo-60.png" alt="">
        </ion-title>
        <ion-buttons slot="end">
            <ion-button color="primary" fill="solid" [routerLink]="IS_NEW_UI_FLOW ? '/auth' : '/login'" routerLinkActive="router-link-active">
                Get Started
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-row class="top web-content-width">
        <ion-col size-sm="12" size-md="6">
            <ion-row class="ion-text-center">
                <ion-col>
                    <h1 class="title">
                        Share Scores In Real Time
                    </h1>
                    <p class="text">
                        iOnCourt is the ultimate tennis, pickleball and padel match tracking app that enables you to track and share match results and statistics using sophisticated tennis analytics in real time. Download app in the store or access it from the your browser on smartphone, tablet
                        or PC.
                    </p>
                </ion-col>
            </ion-row>

            <ion-row style="margin: 30px;">
                <ion-col class="ion-text-right" (click)="openAppStore()">
                    <ion-img src="../assets/img/apple-app-store-en.svg"></ion-img>
                </ion-col>
                <ion-col class="ion-text-left" (click)="openPlayStore()">
                    <ion-img src="../assets/img/google-play-en.png"></ion-img>
                </ion-col>
            </ion-row>
        </ion-col>
        <ion-col size="6" class="ion-hide-sm-down">
            <swiper-container autoplay="true" speed="1000" loop="true">
                <swiper-slide *ngFor="let slide of slidePages; let i = index">
                    <ion-img style="height: 100%;" [src]="slide.img"></ion-img>
                </swiper-slide>
            </swiper-container>
        </ion-col>
    </ion-row>

    <ion-row class="action">
        <ion-col size="12">
            <div class="web-content-width">
                <h2 class="title">
                    Stay on Top of Every Rally!
                </h2>
                <p class="text">
                    Never miss a moment of the action with live scores for your favorite racket sports—tennis, padel, pickleball, and more—whether it's professional leagues, college competitions, or high-stakes tournaments, our platform delivers up-to-the-second updates on every serve, rally, and point, keeping fans, players, and coaches connected no matter where they are.
                </p>

                <ion-button class="ion-margin-top" (click)="openRequestForm()">
                    Add live score to your event
                </ion-button>
            </div>
        </ion-col>
    </ion-row>

    <ion-row>
        <ion-col size="12">
            <h2 class="website-title web-content-width">Features</h2>
            <!-- <h2 class="website-subtitle web-content-width">Features</h2> -->
        </ion-col>
    </ion-row>
    <ion-row class="web-content-width">
        <ion-col size-xs="12" size-md="6" *ngFor="let card of cards">
            <ion-card style="min-height: 100%;">
                <ion-card-header>
                    <ion-card-title>
                        <ion-item (click)="onClick()" lines="none">
                            <ion-label>
                                <h1>{{ card.title }}</h1>
                            </ion-label>
                            <ion-icon color="secondary" slot="start" [name]="card.icon"></ion-icon>
                        </ion-item>
                        <!-- {{ card.title }} -->
                    </ion-card-title>
                </ion-card-header>
                <ion-card-content>
                    {{ card.content }}
                    <ion-item *ngIf="card.link" lines="none">
                        <ion-button fill="clear" (click)="openLink(card.link)">
                            <ion-icon slot="start" name="eye"></ion-icon>
                            View
                        </ion-button>
                    </ion-item>
                </ion-card-content>
            </ion-card>
        </ion-col>

    </ion-row>

    <ion-row class="quote">
        <ion-col size="12">
            <div class="text web-content-width">
                "As a coach with multiple players on different courts, this was so helpful. I could be on one court and check match scores on a different and make decisions as to where I needed to go. Thanks for a user friendly, great platform." Justiss, W, Texas High
                School
            </div>
        </ion-col>
    </ion-row>

    <div class="footer">
        <ion-row>
            <ion-col size="12" size-md="6" class="ion-text-left web-content-width">
                <ion-button [routerLink]="['/feedback']" routerLinkActive="/feedback" routerDirection="forward" fill="clear">
                    <ion-icon slot="start" name="mail"></ion-icon>
                </ion-button>
                <ion-button (click)="openSocial('facebook')" fill="clear">
                    <ion-icon slot="icon-only" name="logo-facebook"></ion-icon>
                </ion-button>
                <ion-button (click)="openSocial('instagram')" fill="clear">
                    <ion-icon slot="icon-only" name="logo-instagram"></ion-icon>
                </ion-button>
                <ion-button (click)="openSocial('twitter')" fill="clear">
                    <ion-icon slot="icon-only" name="logo-twitter"></ion-icon>
                </ion-button>
            </ion-col>

            <ion-col size="12" size-md="6" class="ion-text-right web-content-width">
                <div>Copyright © 2023 iOnCourt, LLC.</div>
            </ion-col>
        </ion-row>
    </div>


</ion-content>